import React from 'react'
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { FaKaggle } from "react-icons/fa";


const HeaderSocials = () => {
  return (
    <div className='Header__socails'>
        <a href="https://www.linkedin.com/in/mohamed-bajadi-788227280/" target='_blank' rel='noreferrer'><BsLinkedin /></a>
        <a href="https://github.com/mohamed-bajadi1" target='_blank' rel='noreferrer'><FaGithub /></a>
        <a href="https://www.kaggle.com/pipoel" target='_blank' rel='noreferrer'><FaKaggle /></a>
    </div>
  )
}

export default HeaderSocials